import { Button } from "@/components/ui/Button";
import { Dialog } from "@/components/ui/Dialog";
import {
  describeExtensionChange,
  suggestCorrectedFileName,
} from "@/features/globalUpload/globalUploadFileName";
import type { GlobalUploadFileEntry } from "@/features/globalUpload/globalUploadConstants";

export function ExtensionWarningDialog({
  open,
  files,
  onApplyCorrectionsAndUpload,
  onConfirm,
  onCancel,
  loading = false,
  zIndexClass = "z-[80]",
}: {
  open: boolean;
  files: GlobalUploadFileEntry[];
  onApplyCorrectionsAndUpload: () => void;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
  zIndexClass?: string;
}) {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      title="Dateiendung geändert"
      size="md"
      zIndexClass={zIndexClass}
      footer={
        <>
          <Button type="button" variant="secondary" onClick={onCancel} disabled={loading}>
            Abbrechen
          </Button>
          <Button type="button" variant="warning" onClick={onConfirm} disabled={loading}>
            Trotzdem hochladen
          </Button>
          <Button type="button" onClick={onApplyCorrectionsAndUpload} loading={loading}>
            Korrigieren und hochladen
          </Button>
        </>
      }
    >
      <div className="space-y-3 text-sm text-label-secondary">
        <p>
          Bei folgenden Dateien wurde die Dateiendung gegenüber der Originaldatei entfernt oder
          verändert. Sie können die vorgeschlagene Korrektur übernehmen oder unverändert
          hochladen.
        </p>
        <ul className="space-y-2 rounded-lg border border-separator bg-card-elevated px-3 py-2">
          {files.map((entry) => {
            const customName = (entry.customName || entry.original.name).trim();
            const suggestedName = suggestCorrectedFileName(entry.original.name, customName);
            const change = describeExtensionChange(entry.original.name, customName);
            return (
              <li key={entry.id} className="text-label">
                <div className="font-medium">{entry.original.name}</div>
                <div className="text-label-secondary">Aktuell: {customName}</div>
                {change ? <div className="text-xs text-status-orange">{change}</div> : null}
                <div className="mt-1 text-xs text-accent">
                  Vorschlag: <span className="font-medium">{suggestedName}</span>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </Dialog>
  );
}
